import gameService from "@/services/game.service";
import { defineStore } from "pinia";
import { toast } from "vue3-toastify";
import { canAssumeRole, getPrimaryUserRole } from "@/utils/permissions";

let inFlightUserFetch = null;

export const useAuthStore = defineStore("auth", {
  state: () => ({
    accessToken: localStorage.getItem("accessToken") || null,
    activeRole: localStorage.getItem("activeRole") || null,
    // user: JSON.parse(localStorage.getItem("user")) || null,
    isAuthModalOpen: false,
    authModalMode: "login", // login, signup, forgotPassword

    isAuthLoading: false,
    hasFetchedUser: false,

    user: {
      // id: 23,
      // email: null,
      // firstName: "Geetha",
      // lastName: "Nama",
      // isTeacher: true,
    },
  }),
  getters: {
    isLoggedIn: (state) => !!state.accessToken,
    isTeacher: (state) => {
      if (!state.user) return false;
      const isTeacherValue = state.user.isTeacher;
      return isTeacherValue === 1 || isTeacherValue === "1" || isTeacherValue === true;
    },
    isAdmin: (state) => {
      if (!state.user) return false;
      const isAdminValue = state.user.isAdmin;
      return isAdminValue === 1 || isAdminValue === "1" || isAdminValue === true;
    },
    isResearcher: (state) => {
      if (!state.user) return false;
      const isResearcherValue = state.user.isResearcher;
      return isResearcherValue === 1 || isResearcherValue === "1" || isResearcherValue === true;
    },
  },
  actions: {
    syncActiveRole(preferredRole = null) {
      const resolvedRole = preferredRole && canAssumeRole(this.user, preferredRole)
        ? preferredRole
        : canAssumeRole(this.user, this.activeRole)
          ? this.activeRole
          : getPrimaryUserRole(this.user);

      this.activeRole = resolvedRole;
      if (resolvedRole) localStorage.setItem("activeRole", resolvedRole);
      else localStorage.removeItem("activeRole");
      return resolvedRole;
    },
    setActiveRole(role) {
      return this.syncActiveRole(role);
    },
    login(token, userData) {
      this.accessToken = token;
      this.user = userData;
      this.hasFetchedUser = true;
      localStorage.setItem("accessToken", token);
      this.syncActiveRole();
      // localStorage.setItem("user", JSON.stringify(userData));
    },
    logout() {
      this.accessToken = null;
      this.user = null;
      this.activeRole = null;
      this.hasFetchedUser = true;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("activeRole");
      // localStorage.removeItem("user");
    },
    checkLogin() {
      const token = localStorage.getItem("accessToken");
      const userData = JSON.parse(localStorage.getItem("user"));
      if (token && userData) {
        this.accessToken = token;
        this.user = userData;
      } else {
        this.logout();
      }
    },
    showAuthModal(mode = "login") {
      this.authModalMode = mode;
      this.isAuthModalOpen = true;
    },
    changeAuthModalMode(mode) {
      // console.log("Changing auth modal mode to:", mode);
      this.authModalMode = mode;
    },
    toggleAuthModalMode() {
      // console.log("Toggling auth modal mode:", this.authModalMode);
      if (this.authModalMode === "login") {
        this.authModalMode = "signup";
      } else if (this.authModalMode === "signup") {
        this.authModalMode = "login";
      }
    },
    closeAuthModal() {
      this.isAuthModalOpen = false;
      this.authModalMode = "login"; // optional: reset
    },
    async fetchUser(force = false) {
      const token = localStorage.getItem("accessToken");
      // console.log("Fetching user with token:", token);
      if (!token) {
        this.user = null;
        this.hasFetchedUser = true;
        return null;
      }

      if (!force && this.hasFetchedUser) {
        return this.user;
      }

      if (!force && inFlightUserFetch) {
        return inFlightUserFetch;
      }

      inFlightUserFetch = (async () => {
        this.isAuthLoading = true;
        try {
          const res = await gameService.getUser();

          if (res.status === 200) {
            this.user = res.data;
            this.syncActiveRole();
            return this.user;
          } else if ([400, 401, 404, 500].includes(res.status)) {
            var errorMessage = res.data.message || "Failed to fetch user.";
            toast(`${errorMessage}`, {
              type: "error",
            });
            if (res.data.error) {
              console.error(res.data.error);
            }
            this.logout();
          } else {
            console.error("Unexpected response:", res);
            this.logout();
          }
        } catch (err) {
          console.error("Error fetching user:", err);
          this.logout();
        } finally {
          this.isAuthLoading = false;
          this.hasFetchedUser = true;
          inFlightUserFetch = null;
        }

        return this.user;
      })();

      return inFlightUserFetch;
    },
  },
});
